import { Injectable } from '@angular/core';
import { LoginApiService } from '../api/login-api.service';
import { Location } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  currentURL: string;

  constructor(private loginApi: LoginApiService,private location:Location) {}

  public isAuthenticated(): boolean {
     let condicion=false;
     
     this.currentURL = this.location.path();
     let myDashboard="/dashboard/";
     let arrayRoutes=this.currentURL.split(myDashboard);
     if(localStorage.getItem('role')!=null && localStorage.getItem('role')=="ROLE_ADMIN"){
       return true;
      }else{
        //return true;
      if(arrayRoutes.length>1){
      if(arrayRoutes[1].indexOf("\/")){
       let fragmentoRuta=arrayRoutes[1].split("\/");
       console.log("ruta 2",fragmentoRuta);
       if(this.loginApi.isLoggedIn()){
          if(localStorage.getItem('documentos')!=null){
            let arrayDocumentos=localStorage.getItem('documentos').split(";");
      
            for (let index = 0; index < (arrayDocumentos.length-1); index++) {
                const element = arrayDocumentos[index].replace("\"","");
                //console.log("element ",element);
                if(element==fragmentoRuta[0]){
                   condicion=true;
                   break;
                }
               
                }
            }  
            if(!condicion){
             this.location.back();
            }
            return this.loginApi.isLoggedIn();
        }else{
          return false;
        }
      
      }
       
    }
  }
     
     //let fragmentoRuta=arrayRoutes[1].split("\\");
    //console.log("ruta ",arrayRoutes);

    
    return this.loginApi.isLoggedIn();
  }

}
